var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expande-horizontal pa-1"},_vm._l((_vm.members),function(member){return _c('baseMember',{key:member._id,attrs:{"member":member,"size":22}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }